import { render, staticRenderFns } from "./EntityHistory.vue?vue&type=template&id=6cd2dc5e"
import script from "./EntityHistory.vue?vue&type=script&lang=js"
export * from "./EntityHistory.vue?vue&type=script&lang=js"
import style0 from "./EntityHistory.vue?vue&type=style&index=0&id=6cd2dc5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports